import { isHoliday } from "./bid/timeOffBidUtils";
import {
  SELECT_FREEDAY_BID_EFFECTIVE_MONTH_LIST,
  SELECT_IAM_DAT_BID_EFFECTIVE_MONTH_LIST,
  SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST,
  SELECT_NON_CONTRACT_BID_EFFECTIVE_MONTH_LIST,
  SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST,
  SELECT_TWU_DAT_FTO_BID_EFFECTIVE_MONTH_LIST,
} from "./constants";
import { getThanksGivingDateOfTheYear } from "./dateHelper";
import { getIsoDateFormat } from "./dateTimeFormatter";

const { DateTime, Interval } = require("luxon");

export function getDayStateForStandardAllotment(year, month, standardCalcDailyAllotment) {
  const converted_month = SELECT_FREEDAY_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amCount: 0, pmCount: 0, eitherCount: 0, amOrPmCount: 0 };
    }

    return {
      date: formattedDate,
      amCount: standardCalcDailyAllotment.amCount,
      eitherCount: standardCalcDailyAllotment.eitherCount,
      pmCount: standardCalcDailyAllotment.pmCount,
      amOrPmCount: standardCalcDailyAllotment.amOrPmCount,
    };
  });

  return formattedDays;
}

export function getDayStateForReliefAllotment(year, month, reliefCalcDailyAllotment) {
  const converted_month = SELECT_FREEDAY_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });

  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amCount: 0, pmCount: 0, amOrPmCount: 0 };
    }

    return {
      date: formattedDate,
      amCount: reliefCalcDailyAllotment.amCount,
      pmCount: reliefCalcDailyAllotment.pmCount,
      amOrPmCount: reliefCalcDailyAllotment.amOrPmCount,
    };
  });

  return formattedDays;
}

export function getFormattedAllotmentDayState(allotments, schedMonth, schedYear) {
  const converted_month = SELECT_FREEDAY_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);

  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });

  const reconstructedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amCount: 0, pmCount: 0, eitherCount: 0, amOrPmCount: 0 };
    }

    // Find the corresponding saved day using the formatted date
    const savedDay = allotments.find((d) => d.date === formattedDate);
    if (savedDay) {
      return {
        ...savedDay,
        date: formattedDate,
      };
    } else {
      // Default values if no saved data is found
      return {
        date: formattedDate,
        amCount: 0,
        pmCount: 0,
        eitherCount: 0,
        amOrPmCount: 0,
      };
    }
  });

  return reconstructedDays;
}

export function getDayStateForIAMFTOAllotment(year, month, calcDailyAllotment) {
  const converted_month = SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });

  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }

    const thanksgivingDate = getThanksGivingDateOfTheYear(converted_year);

    if ((converted_month === 11 || converted_month === 12) && isHoliday(date, converted_year, thanksgivingDate)) {
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }

    return {
      date: formattedDate,
      amOrPmCount: calcDailyAllotment.amOrPmCount,
    };
  });
  return formattedDays;
}

export function getFormattedIAMFTOAllotmentDayState(allotments, schedMonth, schedYear) {
  const converted_month = SELECT_IAM_FTO_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);

  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });

  const reconstructedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }

    // Find the corresponding saved day using the formatted date
    const savedDay = allotments.find((d) => d.date === formattedDate);
    if (savedDay) {
      return {
        ...savedDay,
        date: formattedDate,
      };
    } else {
      // Default values if no saved data is found
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
  });

  return reconstructedDays;
}

export function getDayStateForTWUDATFTOAllotment(year, month, calcDailyAllotment) {
  const converted_month = SELECT_TWU_DAT_FTO_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    const thanksgivingDate = getThanksGivingDateOfTheYear(converted_year);
    if ((converted_month === 11 || converted_month === 12) && isHoliday(date, converted_year, thanksgivingDate)) {
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
    return {
      date: formattedDate,
      amOrPmCount: calcDailyAllotment.amOrPmCount,
    };
  });
  return formattedDays;
}

export function getFormattedTWUDATFTOAllotmentDayState(allotments, schedMonth, schedYear) {
  const converted_month = SELECT_TWU_DAT_FTO_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const reconstructedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    // Find the corresponding saved day using the formatted date
    const savedDay = allotments.find((d) => d.date === formattedDate);
    if (savedDay) {
      return {
        ...savedDay,
        date: formattedDate,
      };
    } else {
      // Default values if no saved data is found
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
  });
  return reconstructedDays;
}

export function getDayStateForScheduleEditor(year, month, schedules) {
  const converted_month = SELECT_SCHEDULE_MANAGEMENT_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");

  //Luxon startOf("week") is always a Monday, .minus({ days: 1 }) sets it to Sunday
  let startOfWeek = startOfMonth.startOf("week").minus({ days: 1 });
  // Given our above conversion, our calendar "startOfWeek" may pull a full week from the prior month.
  // This will only happen if the first of the month is on a Sunday.
  // If this occurs, set our first week to start on the 1st of the month.
  if (startOfMonth.endOf("week").minus({ days: 1 }) < startOfMonth) {
    startOfWeek = startOfMonth;
  }

  // Given the conversion above, endOf("week") for endOfMonth could be Sunday for certain months (since Luxon last day of week is Sunday).
  // This will not give us the full last week for that month.
  // If this ocurrs, add 1 day to endOfMonth to get the full last week at endOf("week").
  // Else, then just set endOfWeek to endOfMonth.endOf("week").minus({ days: 1 }) to get the regular last week.
  let endOfWeek;
  if (endOfMonth.weekday === 7) {
    let firstWeekOfNextMonth = endOfMonth.plus({ days: 1 }).endOf("week");
    endOfWeek = firstWeekOfNextMonth.minus({ days: 1 });
  } else {
    endOfWeek = endOfMonth.endOf("week").minus({ days: 1 });
  }

  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    let scheduleState = {};

    scheduleState.scheduleData = schedules.length > 0 ? schedules.filter((s) => s.date === formattedDate) : null;

    if (date < startOfMonth || date > endOfMonth) {
      scheduleState.additionalDate = formattedDate;
    } else {
      scheduleState.date = formattedDate;
    }

    return scheduleState;
  });

  return formattedDays;
}

export function getDayStateForIAMDATAllotment(year, month, calcDailyAllotment) {
  const converted_month = SELECT_IAM_DAT_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    const thanksgivingDate = getThanksGivingDateOfTheYear(converted_year);
    if ((converted_month === 11 || converted_month === 12) && isHoliday(date, converted_year, thanksgivingDate)) {
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
    return {
      date: formattedDate,
      amOrPmCount: calcDailyAllotment.amOrPmCount,
    };
  });
  return formattedDays;
}

export function getFormattedIAMDATAllotmentDayState(allotments, schedMonth, schedYear) {
  const converted_month = SELECT_IAM_DAT_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const reconstructedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    // Find the corresponding saved day using the formatted date
    const savedDay = allotments.find((d) => d.date === formattedDate);
    if (savedDay) {
      return {
        ...savedDay,
        date: formattedDate,
      };
    } else {
      // Default values if no saved data is found
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
  });
  return reconstructedDays;
}

export function getDayStateForNCBidAllotment(year, month, calcDailyAllotment) {
  const converted_month = SELECT_NON_CONTRACT_BID_EFFECTIVE_MONTH_LIST.indexOf(month) + 1;
  const converted_year = parseInt(year);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const formattedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    const thanksgivingDate = getThanksGivingDateOfTheYear(converted_year);
    if ((converted_month === 11 || converted_month === 12) && isHoliday(date, converted_year, thanksgivingDate)) {
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
    return {
      date: formattedDate,
      amOrPmCount: calcDailyAllotment.amOrPmCount,
    };
  });
  return formattedDays;
}

export function getFormattedNCBidAllotmentDayState(allotments, schedMonth, schedYear) {
  const converted_month = SELECT_NON_CONTRACT_BID_EFFECTIVE_MONTH_LIST.indexOf(schedMonth) + 1;
  const converted_year = parseInt(schedYear);
  const startOfMonth = DateTime.local(converted_year, converted_month).startOf("month");
  const endOfMonth = DateTime.local(converted_year, converted_month).endOf("month");
  const startOfWeek = startOfMonth.startOf("week", { useLocaleWeeks: true });
  const endOfWeek = endOfMonth.endOf("week", { useLocaleWeeks: true });
  const range = Interval.fromDateTimes(startOfWeek, endOfWeek).splitBy({ days: 1 });
  const reconstructedDays = range.map((day) => {
    const date = day.start;
    const formattedDate = getIsoDateFormat(date);
    if (date < startOfMonth || date > endOfMonth) {
      return { date: "", amOrPmCount: 0 };
    }
    // Find the corresponding saved day using the formatted date
    const savedDay = allotments.find((d) => d.date === formattedDate);
    if (savedDay) {
      return {
        ...savedDay,
        date: formattedDate,
      };
    } else {
      // Default values if no saved data is found
      return {
        date: formattedDate,
        amOrPmCount: 0,
      };
    }
  });
  return reconstructedDays;
}
